(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-keller-support"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function openIntercom(attempt) {
      if (typeof window.Intercom === 'function') {
        window.Intercom('show');
        return;
      }

      var launcher = document.querySelector('.intercom-lightweight-app-launcher, .intercom-launcher');
      if (launcher) {
        launcher.click();
        return;
      }

      if (attempt < 20) {
        window.setTimeout(function () {
          openIntercom(attempt + 1);
        }, 200);
      }
    }

    function initRoot(root) {
      if (!root || root.dataset.aboutKellerSupportBound === 'true') return;
      root.dataset.aboutKellerSupportBound = 'true';

      root.addEventListener('click', function (event) {
        var trigger = event.target.closest('[data-about-keller-intercom]');
        if (!trigger || !root.contains(trigger)) return;
        event.preventDefault();
        openIntercom(0);
      });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-about-keller-support]').forEach(initRoot);
    }

    initAll();
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["education-contact"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.eduContactChatBound) return;
    window.eduContactChatBound = true;

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest && event.target.closest('[data-edu-open-chat]');
      if (!trigger) return;
      event.preventDefault();
      if (typeof window.Intercom === 'function') {
        window.Intercom('show');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["education-schedule"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var JS_SRC = 'https://assets.calendly.com/assets/external/widget.js';
    var CSS_HREF = 'https://assets.calendly.com/assets/external/widget.css';
    var ROOT_MARGIN = '600px';
    var loading = null;

    function loadCalendly() {
      if (window.Calendly) return Promise.resolve();
      if (loading) return loading;

      if (!document.querySelector('link[href="' + CSS_HREF + '"]')) {
        var css = document.createElement('link');
        css.rel = 'stylesheet';
        css.href = CSS_HREF;
        document.head.appendChild(css);
      }

      loading = new Promise(function (resolve, reject) {
        var existing = document.querySelector('script[src="' + JS_SRC + '"]');
        if (existing) {
          existing.addEventListener('load', function () { resolve(); }, { once: true });
          return;
        }
        var script = document.createElement('script');
        script.src = JS_SRC;
        script.async = true;
        script.onload = function () { resolve(); };
        script.onerror = reject;
        document.head.appendChild(script);
      });
      return loading;
    }

    function initWidgets() {
      if (window.Calendly && typeof window.Calendly.initInlineWidgets === 'function') {
        window.Calendly.initInlineWidgets();
      }
    }

    function setup(root) {
      var widget = (root || document).querySelector('[data-edu-calendly]');
      if (!widget || widget.dataset.eduCalendlyBound === 'true') return;
      widget.dataset.eduCalendlyBound = 'true';

      if (!('IntersectionObserver' in window)) {
        loadCalendly().then(initWidgets);
        return;
      }

      var observer = new IntersectionObserver(function (entries, obs) {
        if (!entries[0].isIntersecting) return;
        obs.disconnect();
        loadCalendly().then(initWidgets);
      }, { rootMargin: ROOT_MARGIN });
      observer.observe(widget);
    }

    function init(root) {
      (root || document).querySelectorAll('#education-schedule').forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (event.target) init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["finance-contact"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function openIntercom(attempt) {
      if (typeof window.Intercom === 'function') {
        window.Intercom('show');
        return;
      }

      var launcher = document.querySelector('.intercom-lightweight-app-launcher, .intercom-launcher');
      if (launcher) {
        launcher.click();
        return;
      }

      if (attempt < 20) {
        window.setTimeout(function () {
          openIntercom(attempt + 1);
        }, 200);
      }
    }

    function initRoot(root) {
      if (!root || root.dataset.financeContactBound === 'true') return;
      root.dataset.financeContactBound = 'true';

      root.addEventListener('click', function (event) {
        var intercomTrigger = event.target.closest('[data-finance-contact-intercom]');
        if (intercomTrigger && root.contains(intercomTrigger)) {
          event.preventDefault();
          openIntercom(0);
        }
      });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-finance-contact]').forEach(initRoot);
    }

    initAll();
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["finance-options"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var LIBRARY_SRC = 'https://na-library.klarnaservices.com/lib.js';

    function refreshKlarna() {
      try {
        if (window.Klarna && window.Klarna.OnsiteMessaging && typeof window.Klarna.OnsiteMessaging.refresh === 'function') {
          window.Klarna.OnsiteMessaging.refresh();
          return;
        }
      } catch (e) {}

      try {
        if (window.KlarnaOnsiteService && typeof window.KlarnaOnsiteService.push === 'function') {
          window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
        }
      } catch (e) {}
    }

    // The Klarna OSM library is stripped from content_for_header in theme.liquid,
    // so pages without the Klarna app block have to load it themselves.
    function ensureKlarnaLibrary(clientId) {
      if (window.Klarna && window.Klarna.OnsiteMessaging) {
        refreshKlarna();
        return;
      }

      var existing = document.querySelector('script[data-finance-klarna-lib]');
      if (existing) {
        existing.addEventListener('load', refreshKlarna);
        return;
      }

      if (!clientId) return;

      var script = document.createElement('script');
      script.async = true;
      script.src = LIBRARY_SRC;
      script.setAttribute('data-client-id', clientId);
      script.setAttribute('data-finance-klarna-lib', '');
      script.addEventListener('load', function () {
        refreshKlarna();
        window.setTimeout(refreshKlarna, 400);
      });
      document.head.appendChild(script);
    }

    function openModal(modal) {
      if (!modal) return;
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      var closeBtn = modal.querySelector('.finance-options__klarna-modal-close');
      if (closeBtn) closeBtn.focus();
      ensureKlarnaLibrary(modal.getAttribute('data-klarna-client-id'));
      refreshKlarna();
      window.setTimeout(refreshKlarna, 400);
    }

    function closeModal(modal) {
      if (!modal) return;
      modal.hidden = true;
      document.documentElement.style.overflow = '';
    }

    function openLinksInNewTab(root) {
      root.querySelectorAll('a[href]').forEach(function (link) {
        if (link.getAttribute('href') === '#' || link.getAttribute('href') === '') return;
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener noreferrer');
      });
    }

    function initRoot(root) {
      if (!root || root.dataset.financeKlarnaInfoBound === 'true') return;
      root.dataset.financeKlarnaInfoBound = 'true';

      openLinksInNewTab(root);

      var modal = root.querySelector('[data-finance-klarna-info-modal]');
      if (!modal) return;

      root.addEventListener('click', function (event) {
        var openTrigger = event.target.closest('[data-finance-klarna-info-open]');
        if (openTrigger && root.contains(openTrigger)) {
          event.preventDefault();
          openModal(modal);
          return;
        }

        var closeTrigger = event.target.closest('[data-finance-klarna-info-close]');
        if (closeTrigger && modal.contains(closeTrigger)) {
          event.preventDefault();
          closeModal(modal);
        }
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !modal.hidden) {
          closeModal(modal);
        }
      });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('.finance-options').forEach(initRoot);
    }

    initAll();
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["get-started"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function openIntercom(attempt) {
      if (typeof window.Intercom === 'function') {
        window.Intercom('show');
        return;
      }

      var launcher = document.querySelector('.intercom-lightweight-app-launcher, .intercom-launcher');
      if (launcher) {
        launcher.click();
        return;
      }

      if (attempt < 20) {
        window.setTimeout(function () {
          openIntercom(attempt + 1);
        }, 200);
      }
    }

    function initRoot(root) {
      if (!root || root.dataset.getStartedBound === 'true') return;
      root.dataset.getStartedBound = 'true';

      root.addEventListener('click', function (event) {
        var intercomTrigger = event.target.closest('[data-get-started-intercom]');
        if (intercomTrigger && root.contains(intercomTrigger)) {
          event.preventDefault();
          openIntercom(0);
        }
      });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-get-started]').forEach(initRoot);
    }

    initAll();
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["k4b-collection-showcase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCarousel(root) {
      if (!root || root.dataset.k4bReady === 'true') return;

      var medias = Array.prototype.slice.call(root.querySelectorAll('[data-k4b-slide-media]'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-k4b-dot]'));
      var total = medias.length;
      if (total < 1) return;

      // Keep dots in sync with the rendered image slides.
      if (dots.length !== total) {
        var dotsWrap = root.querySelector('[data-k4b-dots]');
        if (dotsWrap) {
          dotsWrap.innerHTML = '';
          for (var d = 0; d < total; d += 1) {
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'k4b-cs__dot' + (d === 0 ? ' is-active' : '');
            btn.setAttribute('data-k4b-dot', '');
            btn.setAttribute('data-index', String(d));
            btn.setAttribute('aria-label', 'Go to slide ' + (d + 1) + ' of ' + total);
            btn.setAttribute('aria-current', d === 0 ? 'true' : 'false');
            dotsWrap.appendChild(btn);
          }
          dots = Array.prototype.slice.call(root.querySelectorAll('[data-k4b-dot]'));
        }
      }

      var index = 0;
      var timer = null;
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var autoplayMs = parseInt(root.getAttribute('data-k4b-autoplay'), 10);
      if (isNaN(autoplayMs) || autoplayMs < 1000) autoplayMs = 3000;

      function show(i) {
        index = ((i % total) + total) % total;
        medias.forEach(function (el, idx) {
          var on = idx === index;
          el.classList.toggle('is-active', on);
          el.setAttribute('aria-hidden', on ? 'false' : 'true');
          var shopLink = el.querySelector('.k4b-cs__shop-chair');
          if (shopLink) {
            if (on) shopLink.removeAttribute('tabindex');
            else shopLink.setAttribute('tabindex', '-1');
          }
        });
        dots.forEach(function (el, idx) {
          var on = idx === index;
          el.classList.toggle('is-active', on);
          el.setAttribute('aria-current', on ? 'true' : 'false');
        });
      }

      function stopAuto() {
        if (timer) {
          window.clearTimeout(timer);
          timer = null;
        }
      }

      function startAuto() {
        stopAuto();
        if (reduceMotion || total < 2) return;
        timer = window.setTimeout(function tick() {
          show(index + 1);
          timer = window.setTimeout(tick, autoplayMs);
        }, autoplayMs);
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var i = parseInt(dot.getAttribute('data-index'), 10);
          if (!isNaN(i)) {
            show(i);
            startAuto();
          }
        });
      });

      root.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          show(index - 1);
          startAuto();
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          show(index + 1);
          startAuto();
        }
      });

      root.addEventListener('focusin', stopAuto);
      root.addEventListener('focusout', function (event) {
        if (!root.contains(event.relatedTarget)) startAuto();
      });

      root.dataset.k4bReady = 'true';
      show(0);
      startAuto();
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-k4b-carousel]').forEach(initCarousel);
    }

    initAll(document);

    document.addEventListener('shopify:section:load', function (event) {
      if (event.target) {
        event.target.querySelectorAll('[data-k4b-carousel]').forEach(function (el) {
          el.dataset.k4bReady = 'false';
        });
        initAll(event.target);
      }
    });

    document.addEventListener('shopify:block:select', function (event) {
      var block = event.target;
      if (!block) return;
      var root = block.closest('[data-k4b-carousel]');
      if (!root) return;
      var media = block.matches('[data-k4b-slide-media]') ? block : block.closest('[data-k4b-slide-media]');
      if (!media) return;
      var idx = parseInt(media.getAttribute('data-index'), 10);
      if (isNaN(idx)) return;
      var medias = root.querySelectorAll('[data-k4b-slide-media]');
      var dots = root.querySelectorAll('[data-k4b-dot]');
      medias.forEach(function (el, i) {
        var on = i === idx;
        el.classList.toggle('is-active', on);
        el.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
      dots.forEach(function (el, i) {
        var on = i === idx;
        el.classList.toggle('is-active', on);
        el.setAttribute('aria-current', on ? 'true' : 'false');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["k4b-contact"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var MOBILE_MQ = '(max-width: 720px)';

    function openIntercom(attempt) {
      if (typeof window.Intercom === 'function') {
        window.Intercom('show');
        return;
      }

      var launcher = document.querySelector('.intercom-lightweight-app-launcher, .intercom-launcher');
      if (launcher) {
        launcher.click();
        return;
      }

      if (attempt < 20) {
        window.setTimeout(function () {
          openIntercom(attempt + 1);
        }, 200);
      }
    }

    function handleIntercomClick(event) {
      var trigger = event.target.closest('[data-k4b-open-intercom]');
      if (!trigger) return;
      event.preventDefault();
      openIntercom(0);
    }

    function isMobile() {
      return window.matchMedia(MOBILE_MQ).matches;
    }

    function formatHours(section) {
      var secondary = section.querySelector('[data-k4b-contact-secondary]');
      if (!secondary || secondary.dataset.k4bHoursReady === 'true') return;
      var p = secondary.querySelector('p') || secondary;
      if (p.querySelector('.k4b-contact__hours-line')) {
        secondary.dataset.k4bHoursReady = 'true';
        return;
      }
      var text = (p.textContent || '').replace(/\s+/g, ' ').trim();
      var parts = text.split(/\s*\|\s*/).filter(Boolean);
      if (parts.length < 2) {
        secondary.dataset.k4bHoursReady = 'true';
        return;
      }
      p.innerHTML = parts
        .map(function (part, index) {
          var html = '<span class="k4b-contact__hours-line">' + part + '</span>';
          if (index < parts.length - 1) {
            html += '<span class="k4b-contact__hours-sep" aria-hidden="true"> | </span>';
          }
          return html;
        })
        .join('');
      secondary.dataset.k4bHoursReady = 'true';
    }

    function actionsRowOverflows(actions, available) {
      if (!actions || available <= 0) return false;
      var prevWrap = actions.style.flexWrap;
      var prevWidth = actions.style.width;
      var prevDir = actions.style.flexDirection;
      actions.classList.remove('k4b-contact__actions--stack');
      actions.style.flexWrap = 'nowrap';
      actions.style.flexDirection = 'row';
      actions.style.width = 'max-content';
      var overflows = actions.scrollWidth > available + 1;
      actions.style.flexWrap = prevWrap;
      actions.style.width = prevWidth;
      actions.style.flexDirection = prevDir;
      return overflows;
    }

    function syncContactLayout(section) {
      if (!section) return;
      formatHours(section);
      var content = section.querySelector('[data-k4b-contact-content]');
      var actions = section.querySelector('.k4b-contact__actions');
      if (actions) actions.classList.remove('k4b-contact__actions--stack');
      if (!isMobile() || !content || !actions) return;
      if (actionsRowOverflows(actions, content.clientWidth)) {
        actions.classList.add('k4b-contact__actions--stack');
      }
    }

    function syncAll(scope) {
      (scope || document).querySelectorAll('.k4b-contact').forEach(syncContactLayout);
    }

    function init() {
      syncAll(document);
      if (typeof ResizeObserver !== 'undefined') {
        document.querySelectorAll('.k4b-contact').forEach(function (section) {
          if (section.dataset.k4bContactResizeBound === 'true') return;
          section.dataset.k4bContactResizeBound = 'true';
          var observer = new ResizeObserver(function () {
            syncContactLayout(section);
          });
          observer.observe(section);
          var content = section.querySelector('[data-k4b-contact-content]');
          if (content) observer.observe(content);
        });
      }
    }

    document.addEventListener('click', handleIntercomClick);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (event) {
      document.removeEventListener('click', handleIntercomClick);
      document.addEventListener('click', handleIntercomClick);
      if (event.target) {
        event.target.querySelectorAll('.k4b-contact').forEach(function (section) {
          section.dataset.k4bContactResizeBound = 'false';
          var secondary = section.querySelector('[data-k4b-contact-secondary]');
          if (secondary) secondary.dataset.k4bHoursReady = 'false';
        });
        syncAll(event.target);
        init();
      }
    });

    window.addEventListener('resize', function () {
      syncAll(document);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["k4b-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var HEADING_MIN_PX = 18;

    function elementOverflows(el, available) {
      if (!el || available <= 0) return false;
      if (el.scrollWidth > available + 1) return true;
      var range = document.createRange();
      range.selectNodeContents(el);
      var rects = range.getClientRects();
      for (var i = 0; i < rects.length; i++) {
        if (rects[i].width > available + 1) return true;
      }
      return false;
    }

    function fitFontSize(el, available, minPx) {
      if (!el || available <= 0) return 1;
      el.style.fontSize = '';
      var baseSize = parseFloat(window.getComputedStyle(el).fontSize);
      if (!baseSize) return 1;

      var size = baseSize;
      var guard = 80;
      while (guard-- > 0 && size > minPx && elementOverflows(el, available)) {
        size -= 1;
        el.style.fontSize = size + 'px';
      }
      return size / baseSize;
    }

    function headingLineCount(heading) {
      if (!heading) return 1;
      var range = document.createRange();
      range.selectNodeContents(heading);
      return Math.max(1, range.getClientRects().length);
    }

    function syncHeroText(section) {
      if (!section) return;
      var content = section.querySelector('[data-k4b-hero-content]');
      var heading = section.querySelector('[data-k4b-hero-heading]');
      var copy = section.querySelector('[data-k4b-hero-copy]');
      if (!content) return;

      var available = content.clientWidth;
      if (heading) {
        heading.classList.remove('is-wrapped');
        heading.style.lineHeight = '';
        fitFontSize(heading, available, HEADING_MIN_PX);
        if (headingLineCount(heading) > 1) {
          heading.classList.add('is-wrapped');
        }
      }

      if (copy) {
        copy.style.maxWidth = '';
        copy.style.fontSize = '';
        var isMobile = window.matchMedia('(max-width: 720px)').matches;
        if (isMobile) {
          copy.style.fontSize = '16px';
        } else if (available > 0) {
          /* Keep copy width stable when the heading font changes. */
          copy.style.maxWidth = Math.max(0, Math.round(available) - 300) + 'px';
        }
      }
    }

    function syncAll(scope) {
      (scope || document).querySelectorAll('.k4b-hero').forEach(syncHeroText);
    }

    function init() {
      syncAll(document);
      if (typeof ResizeObserver !== 'undefined') {
        document.querySelectorAll('.k4b-hero').forEach(function (section) {
          if (section.dataset.k4bHeroResizeBound === 'true') return;
          section.dataset.k4bHeroResizeBound = 'true';
          var observer = new ResizeObserver(function () {
            syncHeroText(section);
          });
          observer.observe(section);
          var content = section.querySelector('[data-k4b-hero-content]');
          var heading = section.querySelector('[data-k4b-hero-heading]');
          if (content) observer.observe(content);
          if (heading) observer.observe(heading);
        });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (event.target) {
        event.target.querySelectorAll('.k4b-hero').forEach(function (section) {
          section.dataset.k4bHeroResizeBound = 'false';
        });
        syncAll(event.target);
        init();
      }
    });

    window.addEventListener('resize', function () {
      syncAll(document);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["k4b-real-shops"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initShopsCarousel(root) {
      if (!root || root.dataset.k4bReady === 'true') return;

      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-k4b-shops-slide]'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-k4b-shops-dot]'));
      var total = slides.length;
      if (total < 2) return;

      var index = 0;
      var mq = window.matchMedia('(max-width: 720px)');

      function show(i) {
        index = (i + total) % total;
        slides.forEach(function (el, idx) {
          var on = idx === index;
          el.classList.toggle('is-active', on);
          el.setAttribute('aria-hidden', on ? 'false' : 'true');
        });
        dots.forEach(function (el, idx) {
          var on = idx === index;
          el.classList.toggle('is-active', on);
          el.setAttribute('aria-current', on ? 'true' : 'false');
        });
      }

      function onDotClick(dot) {
        return function () {
          if (!mq.matches) return;
          var i = parseInt(dot.getAttribute('data-index'), 10);
          if (!isNaN(i)) show(i);
        };
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', onDotClick(dot));
      });

      root.addEventListener('keydown', function (event) {
        if (!mq.matches) return;
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          show(index - 1);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          show(index + 1);
        }
      });

      function syncDesktop() {
        if (mq.matches) {
          show(index);
        } else {
          slides.forEach(function (el) {
            el.classList.add('is-active');
            el.setAttribute('aria-hidden', 'false');
          });
          dots.forEach(function (el, idx) {
            var on = idx === 0;
            el.classList.toggle('is-active', on);
            el.setAttribute('aria-current', on ? 'true' : 'false');
          });
        }
      }

      if (typeof mq.addEventListener === 'function') {
        mq.addEventListener('change', syncDesktop);
      } else if (typeof mq.addListener === 'function') {
        mq.addListener(syncDesktop);
      }

      root.dataset.k4bReady = 'true';
      syncDesktop();
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-k4b-shops-carousel]').forEach(initShopsCarousel);
    }

    initAll(document);

    document.addEventListener('shopify:section:load', function (event) {
      if (!event.target) return;
      event.target.querySelectorAll('[data-k4b-shops-carousel]').forEach(function (el) {
        el.dataset.k4bReady = 'false';
      });
      initAll(event.target);
    });

    document.addEventListener('shopify:block:select', function (event) {
      var block = event.target;
      if (!block) return;
      var root = block.closest('[data-k4b-shops-carousel]');
      if (!root) return;
      var slide = block.matches('[data-k4b-shops-slide]') ? block : block.closest('[data-k4b-shops-slide]');
      if (!slide) return;
      var idx = parseInt(slide.getAttribute('data-index'), 10);
      if (isNaN(idx)) return;
      if (!window.matchMedia('(max-width: 720px)').matches) return;
      var slides = root.querySelectorAll('[data-k4b-shops-slide]');
      var dots = root.querySelectorAll('[data-k4b-shops-dot]');
      slides.forEach(function (el, i) {
        var on = i === idx;
        el.classList.toggle('is-active', on);
        el.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
      dots.forEach(function (el, i) {
        var on = i === idx;
        el.classList.toggle('is-active', on);
        el.setAttribute('aria-current', on ? 'true' : 'false');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["k4b-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initReviews(root) {
      if (!root || root.dataset.k4bReady === 'true') return;

      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-k4b-review-slide]'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-k4b-review-dot]'));
      var total = slides.length;
      if (total < 1) return;

      var index = 0;
      var timer = null;
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function show(i, opts) {
        index = (i + total) % total;
        slides.forEach(function (el, idx) {
          var on = idx === index;
          el.classList.toggle('is-active', on);
          el.setAttribute('aria-hidden', on ? 'false' : 'true');
        });
        dots.forEach(function (el, idx) {
          var on = idx === index;
          el.classList.toggle('is-active', on);
          el.setAttribute('aria-current', on ? 'true' : 'false');
        });
        if (opts && opts.skipFit) return;
        var section = root.closest('.k4b-reviews');
        if (section && root.dataset.k4bReady === 'true') {
          fitCopy(section);
          schedulePlaceOpenQmark();
        }
      }

      function setScoreScale(section, scale) {
        section.style.setProperty('--k4b-reviews-score-scale', String(scale));
      }

      function setCopyScale(section, scale) {
        section.style.setProperty('--k4b-reviews-copy-scale', String(scale));
      }

      function lockCopyHeight() {
        var copy = root.querySelector('.k4b-reviews__copy');
        if (!copy || !slides.length) return;

        copy.style.minHeight = '';
        var max = 0;

        slides.forEach(function (slide) {
          slide.style.display = 'flex';
          slide.style.flexDirection = 'column';
          slide.style.alignItems = 'center';
          slide.style.visibility = 'hidden';
          slide.style.position = 'absolute';
          slide.style.left = '0';
          slide.style.right = '0';
          slide.style.top = '0';
          slide.style.width = '100%';
          slide.style.pointerEvents = 'none';
          max = Math.max(max, slide.offsetHeight);
          slide.style.display = '';
          slide.style.flexDirection = '';
          slide.style.alignItems = '';
          slide.style.visibility = '';
          slide.style.position = '';
          slide.style.left = '';
          slide.style.right = '';
          slide.style.top = '';
          slide.style.width = '';
          slide.style.pointerEvents = '';
        });

        show(index, { skipFit: true });
        if (max > 0) {
          copy.style.minHeight = Math.ceil(max) + 'px';
        }
      }

      function fitSummary(section) {
        var strong = section.querySelector('.k4b-reviews__score strong');
        var summary = section.querySelector('[data-k4b-reviews-summary]');
        if (!strong || !summary) return;

        summary.style.fontSize = '';
        summary.style.letterSpacing = '0px';
        summary.style.display = 'block';
        summary.style.whiteSpace = 'nowrap';
        summary.style.textAlign = 'center';
        strong.style.width = 'max-content';
        strong.style.marginInline = 'auto';
        summary.style.width = 'max-content';
        summary.style.marginInline = 'auto';

        var target = Math.ceil(strong.getBoundingClientRect().width);
        if (!target) {
          strong.style.width = '100%';
          strong.style.marginInline = '';
          summary.style.width = '100%';
          summary.style.marginInline = '';
          return;
        }

        var base = 40;
        var scale = parseFloat(
          getComputedStyle(section).getPropertyValue('--k4b-reviews-score-scale')
        ) || 1;
        var size = base * scale;
        var minSize = Math.max(16, 22 * scale);
        summary.style.fontSize = size + 'px';
        var guard = 0;
        while (
          summary.getBoundingClientRect().width > target + 1 &&
          size > minSize &&
          guard < 120
        ) {
          size -= 0.25;
          summary.style.fontSize = size + 'px';
          guard += 1;
        }

        strong.style.width = '100%';
        strong.style.marginInline = '';
        summary.style.width = '100%';
        summary.style.marginInline = '';
      }

      function columnWidth(el) {
        if (!el) return 0;
        var prevWidth = el.style.width;
        var prevMax = el.style.maxWidth;
        el.style.width = '100%';
        el.style.maxWidth = '380px';
        var available = el.clientWidth;
        el.style.width = prevWidth;
        el.style.maxWidth = prevMax;
        return available;
      }

      function fitScore(section) {
        var score = section.querySelector('.k4b-reviews__score');
        if (!score) return;

        setScoreScale(section, 1);
        fitSummary(section);

        /* Stacked score/review layout is already finalized. */
        if (window.matchMedia('(max-width: 720px)').matches) return;

        var available = columnWidth(score);
        if (available <= 0) return;

        /*
          Side-by-side: when the column gets narrower than the natural box,
          scale width, height, padding, and type together (same ratio).
        */
        var prevMax = score.style.maxWidth;
        score.style.maxWidth = 'none';
        var natural = score.getBoundingClientRect().width;
        score.style.maxWidth = prevMax;
        if (natural <= 0) return;

        var scale = Math.min(1, available / natural);
        scale = Math.max(0.65, Math.round(scale * 1000) / 1000);
        setScoreScale(section, scale);
        fitSummary(section);
      }

      function fitCopy(section) {
        setCopyScale(section, 1);
        var active = root.querySelector('.k4b-reviews__slide.is-active .k4b-reviews__framed');
        if (!active) return;

        var available = root.clientWidth;
        if (available <= 0) return;

        var scale = 1;
        var guard = 40;
        while (guard-- > 0 && scale > 0.6 && active.scrollWidth > available + 1) {
          scale = Math.max(0.6, Math.round((scale - 0.03) * 100) / 100);
          setCopyScale(section, scale);
        }
      }

      var placeOpenQmarkTries = 0;

      function schedulePlaceOpenQmark() {
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(placeOpenQmark);
        });
      }

      function rectsOverlap(a, b, pad) {
        pad = pad || 0;
        return !(
          a.right <= b.left - pad ||
          a.left >= b.right + pad ||
          a.bottom <= b.top - pad ||
          a.top >= b.bottom + pad
        );
      }

      function placeOpenQmark() {
        var slide = root.querySelector('.k4b-reviews__slide.is-active');
        if (!slide) return;

        var row = slide.querySelector('.k4b-reviews__heading-row');
        var body = slide.querySelector('.k4b-reviews__body');
        var open = slide.querySelector('.k4b-reviews__qmark--open');
        var close = slide.querySelector('.k4b-reviews__qmark--close');
        var heading = slide.querySelector('.k4b-reviews__heading');
        var quote =
          slide.querySelector('.k4b-reviews__quote span') ||
          slide.querySelector('.k4b-reviews__quote');
        if (!row || !body || !open || !close || !heading || !quote) return;

        var nudge = 80;
        var clearGap = 6;

        open.style.visibility = 'hidden';

        /* Pin closing mark center to the quote's right edge (keep its vertical CSS). */
        close.style.right = 'auto';
        close.style.left = '0px';
        close.style.transform = 'translateX(-50%) translateY(-10px) rotate(180deg)';

        var bodyRect = body.getBoundingClientRect();
        var quoteRect = quote.getBoundingClientRect();
        close.style.left = quoteRect.right - bodyRect.left + 'px';

        /* Measure open mark without leaving it parked on the heading. */
        open.style.right = 'auto';
        open.style.bottom = 'auto';
        open.style.transform = 'none';
        open.style.left = '-9999px';
        open.style.top = '0px';

        var openSize = open.getBoundingClientRect();
        var openH = openSize.height;
        var openW = openSize.width;
        if (!openH || !openW) {
          placeOpenQmarkTries += 1;
          if (placeOpenQmarkTries < 12) {
            window.requestAnimationFrame(placeOpenQmark);
          }
          return;
        }
        placeOpenQmarkTries = 0;

        var rowRect = row.getBoundingClientRect();
        var headingRect = heading.getBoundingClientRect();

        open.style.top = headingRect.top - rowRect.top - openH + nudge + 'px';

        /*
          Mirror the closing mark: same distance from the quote center,
          on the opposite side. left is the mark's left edge (no -50% transform).
        */
        quoteRect = quote.getBoundingClientRect();
        var closeRect = close.getBoundingClientRect();
        var quoteCenter = (quoteRect.left + quoteRect.right) / 2;
        var closeCenter = (closeRect.left + closeRect.right) / 2;
        var openCenter = quoteCenter - (closeCenter - quoteCenter);
        open.style.left = openCenter - rowRect.left - openW / 2 - 15 + 'px';
        open.style.visibility = 'visible';

        /*
          Push left until the mark no longer overlaps the heading or quote text.
        */
        var framed = slide.querySelector('.k4b-reviews__framed');
        var framedLeft = framed ? framed.getBoundingClientRect().left : rowRect.left;
        var guard = 0;
        while (guard++ < 320) {
          var openRect = open.getBoundingClientRect();
          headingRect = heading.getBoundingClientRect();
          quoteRect = quote.getBoundingClientRect();
          var overlapsText =
            rectsOverlap(openRect, headingRect, clearGap) ||
            rectsOverlap(openRect, quoteRect, clearGap);
          if (!overlapsText) break;

          open.style.left = (parseFloat(open.style.left) || 0) - 2 + 'px';
          openRect = open.getBoundingClientRect();
          if (openRect.left < framedLeft - 64) break;
        }
      }

      function syncLayout() {
        var section = root.closest('.k4b-reviews');
        if (!section) return;
        setScoreScale(section, 1);
        setCopyScale(section, 1);
        lockCopyHeight();
        fitScore(section);
        fitCopy(section);
        fitSummary(section);
        schedulePlaceOpenQmark();
      }

      function stopAuto() {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      }

      function startAuto() {
        stopAuto();
        if (reduceMotion || total < 2) return;
        timer = window.setInterval(function () {
          show(index + 1);
        }, 5000);
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var i = parseInt(dot.getAttribute('data-index'), 10);
          if (!isNaN(i)) {
            show(i);
            startAuto();
          }
        });
      });

      root.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          show(index - 1);
          startAuto();
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          show(index + 1);
          startAuto();
        }
      });

      root.addEventListener('focusin', stopAuto);
      root.addEventListener('focusout', function (event) {
        if (!root.contains(event.relatedTarget)) startAuto();
      });

      root.dataset.k4bReady = 'true';
      show(0, { skipFit: true });
      syncLayout();
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () {
          syncLayout();
          schedulePlaceOpenQmark();
        });
      }
      window.addEventListener('load', function () {
        syncLayout();
      });
      window.addEventListener('resize', syncLayout);
      startAuto();
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-k4b-reviews-carousel]').forEach(initReviews);
    }

    initAll(document);

    document.addEventListener('shopify:section:load', function (event) {
      if (!event.target) return;
      event.target.querySelectorAll('[data-k4b-reviews-carousel]').forEach(function (el) {
        el.dataset.k4bReady = 'false';
      });
      initAll(event.target);
    });

    document.addEventListener('shopify:block:select', function (event) {
      var block = event.target;
      if (!block) return;
      var root = block.closest('[data-k4b-reviews-carousel]');
      if (!root) return;
      var slide = block.matches('[data-k4b-review-slide]') ? block : block.closest('[data-k4b-review-slide]');
      if (!slide) return;
      var idx = parseInt(slide.getAttribute('data-index'), 10);
      if (isNaN(idx)) return;
      var slides = root.querySelectorAll('[data-k4b-review-slide]');
      var dots = root.querySelectorAll('[data-k4b-review-dot]');
      slides.forEach(function (el, i) {
        var on = i === idx;
        el.classList.toggle('is-active', on);
        el.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
      dots.forEach(function (el, i) {
        var on = i === idx;
        el.classList.toggle('is-active', on);
        el.setAttribute('aria-current', on ? 'true' : 'false');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["k4b-trust"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var HEADING_FIT_MQ = '(max-width: 330px)';
    var VALUE_FIT_MQ = '(max-width: 550px)';
    var MIN_HEADING_SCALE = 0.48;
    var MIN_VALUE_SCALE = 0.62;

    function setHeadingFit(section, scale) {
      section.style.setProperty('--k4b-trust-fit', String(scale));
    }

    function setValueFit(section, scale) {
      section.style.setProperty('--k4b-trust-value-fit', String(scale));
    }

    function overflows(el) {
      if (!el) return false;
      return el.scrollWidth > el.clientWidth + 1;
    }

    function syncTrustFit(section) {
      if (!section) return;
      setHeadingFit(section, 1);
      setValueFit(section, 1);

      if (window.matchMedia(HEADING_FIT_MQ).matches) {
        var heading = section.querySelector('.k4b-trust__heading');
        if (heading) {
          var headingScale = 1;
          var headingGuard = 50;
          while (headingGuard-- > 0 && headingScale > MIN_HEADING_SCALE && overflows(heading)) {
            headingScale = Math.max(MIN_HEADING_SCALE, Math.round((headingScale - 0.02) * 100) / 100);
            setHeadingFit(section, headingScale);
          }
        }
      }

      if (window.matchMedia(VALUE_FIT_MQ).matches) {
        var values = section.querySelectorAll('.k4b-trust__value');
        if (values.length) {
          var valueScale = 1;
          var valueGuard = 40;

          function anyValueOverflows() {
            for (var i = 0; i < values.length; i++) {
              if (overflows(values[i])) return true;
            }
            return false;
          }

          while (valueGuard-- > 0 && valueScale > MIN_VALUE_SCALE && anyValueOverflows()) {
            valueScale = Math.max(MIN_VALUE_SCALE, Math.round((valueScale - 0.02) * 100) / 100);
            setValueFit(section, valueScale);
          }
        }
      }
    }

    function syncAll(scope) {
      (scope || document).querySelectorAll('.k4b-trust').forEach(syncTrustFit);
    }

    function init() {
      syncAll(document);
      if (typeof ResizeObserver === 'undefined') return;
      document.querySelectorAll('.k4b-trust').forEach(function (section) {
        if (section.dataset.k4bTrustResizeBound === 'true') return;
        section.dataset.k4bTrustResizeBound = 'true';
        var observer = new ResizeObserver(function () {
          syncTrustFit(section);
        });
        observer.observe(section);
        var inner = section.querySelector('.k4b-trust__inner');
        if (inner) observer.observe(inner);
        var grid = section.querySelector('.k4b-trust__grid');
        if (grid) observer.observe(grid);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (!event.target) return;
      event.target.querySelectorAll('.k4b-trust').forEach(function (section) {
        section.dataset.k4bTrustResizeBound = 'false';
      });
      syncAll(event.target);
      init();
    });

    window.addEventListener('resize', function () {
      syncAll(document);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["schedule-an-appointment"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var cssHref = 'https://assets.calendly.com/assets/external/widget.css';
    var jsSrc = 'https://assets.calendly.com/assets/external/widget.js';
    var loading = null;

    function loadCalendlyAssets() {
      if (typeof Calendly !== 'undefined') {
        return Promise.resolve();
      }
      if (loading) return loading;

      if (!document.querySelector('link[href="' + cssHref + '"]')) {
        var css = document.createElement('link');
        css.rel = 'stylesheet';
        css.href = cssHref;
        document.head.appendChild(css);
      }

      var existing = document.querySelector('script[src*="assets.calendly.com/assets/external/widget.js"]');
      if (existing) {
        loading = new Promise(function (resolve) {
          if (typeof Calendly !== 'undefined') {
            resolve();
            return;
          }
          existing.addEventListener('load', function () { resolve(); }, { once: true });
        });
        return loading;
      }

      loading = new Promise(function (resolve, reject) {
        var script = document.createElement('script');
        script.src = jsSrc;
        script.async = true;
        script.onload = function () { resolve(); };
        script.onerror = reject;
        document.head.appendChild(script);
      });
      return loading;
    }

    function setCalendlyHeight(el, height, addBuffer) {
      if (!el || !height) return;
      var px = typeof height === 'number' ? height : parseInt(height, 10);
      if (!px) return;
      if (addBuffer) px += 32;
      if (px < 700) px = 700;

      var root = el.closest('.visit-us');
      if (root) root.style.setProperty('--vu-calendly-height', px + 'px');
      el.style.height = px + 'px';
      var iframe = el.querySelector('iframe');
      if (iframe) iframe.style.height = px + 'px';
    }

    function initWidget(el) {
      if (!el || typeof Calendly === 'undefined') return false;
      if (el.dataset.initialized === 'true') return true;
      el.dataset.initialized = 'true';
      el.replaceChildren();
      Calendly.initInlineWidget({
        url: el.getAttribute('data-url'),
        parentElement: el,
        resize: true
      });
      return true;
    }

    function initAll(scope) {
      var root = scope || document;
      var widgets = root.querySelectorAll('[data-visit-us-calendly]');
      if (!widgets.length) return;

      var pending = Array.prototype.slice.call(widgets);
      var retryTimer;

      function tryInit() {
        pending = pending.filter(function (widget) {
          return !initWidget(widget);
        });
        if (!pending.length && retryTimer) {
          window.clearInterval(retryTimer);
        }
      }

      loadCalendlyAssets().then(tryInit).catch(function () {});
      retryTimer = window.setInterval(tryInit, 300);
      window.setTimeout(function () {
        window.clearInterval(retryTimer);
      }, 10000);
    }

    function bindResize() {
      if (window.__kellerVisitUsCalendlyResize) return;
      window.__kellerVisitUsCalendlyResize = true;

      window.addEventListener('message', function (event) {
        if (!event.origin || event.origin.indexOf('calendly.com') === -1) return;
        var data = event.data;
        if (!data || data.event !== 'calendly.page_height') return;
        var height = data.payload && data.payload.height;
        document.querySelectorAll('[data-visit-us-calendly]').forEach(function (widget) {
          setCalendlyHeight(widget, height, true);
        });
      });
    }

    function start() {
      bindResize();
      initAll();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }

    document.addEventListener('shopify:section:load', function (event) {
      bindResize();
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scholarship-content"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function closeItem(trigger, panel) {
      trigger.setAttribute('aria-expanded', 'false');
      panel.hidden = true;
    }

    function openItem(trigger, panel) {
      trigger.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
    }

    function parseYmd(value) {
      if (!value) return null;
      var match = String(value).trim().match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (!match) return null;
      var year = Number(match[1]);
      var month = Number(match[2]);
      var day = Number(match[3]);
      if (month < 1 || month > 12 || day < 1 || day > 31) return null;
      return { year: year, month: month, day: day, raw: match[0] };
    }

    function pad(n) {
      return String(n).padStart(2, '0');
    }

    function toCompact(dateParts) {
      return String(dateParts.year) + pad(dateParts.month) + pad(dateParts.day);
    }

    function nextDay(dateParts) {
      var date = new Date(Date.UTC(dateParts.year, dateParts.month - 1, dateParts.day));
      date.setUTCDate(date.getUTCDate() + 1);
      return {
        year: date.getUTCFullYear(),
        month: date.getUTCMonth() + 1,
        day: date.getUTCDate(),
        raw:
          date.getUTCFullYear() +
          '-' +
          pad(date.getUTCMonth() + 1) +
          '-' +
          pad(date.getUTCDate())
      };
    }

    function googleCalendarUrl(title, dateParts, description) {
      var start = toCompact(dateParts);
      var end = toCompact(nextDay(dateParts));
      return (
        'https://calendar.google.com/calendar/render?action=TEMPLATE' +
        '&text=' + encodeURIComponent(title || '') +
        '&dates=' + encodeURIComponent(start + '/' + end) +
        '&details=' + encodeURIComponent(description || '')
      );
    }

    function icsEscape(text) {
      return String(text || '')
        .replace(/\\/g, '\\\\')
        .replace(/\n/g, '\\n')
        .replace(/,/g, '\\,')
        .replace(/;/g, '\\;');
    }

    function stampUtc() {
      var now = new Date();
      return (
        now.getUTCFullYear() +
        pad(now.getUTCMonth() + 1) +
        pad(now.getUTCDate()) +
        'T' +
        pad(now.getUTCHours()) +
        pad(now.getUTCMinutes()) +
        pad(now.getUTCSeconds()) +
        'Z'
      );
    }

    function parseReminders(value) {
      if (!value) return [1];
      return String(value)
        .split(',')
        .map(function (part) {
          return Number(String(part).trim());
        })
        .filter(function (days) {
          return Number.isFinite(days) && days >= 0;
        });
    }

    function alarmBlocks(title, reminderDays, dateParts) {
      var alarms = [];
      (reminderDays.length ? reminderDays : [1]).forEach(function (days) {
        var trigger;
        if (days === 0 && dateParts) {
          // Day-of reminder at 9:00 AM on the event date (reliable for all-day events)
          trigger =
            'TRIGGER;VALUE=DATE-TIME:' +
            String(dateParts.year) +
            pad(dateParts.month) +
            pad(dateParts.day) +
            'T090000';
        } else if (days === 0) {
          trigger = 'TRIGGER:PT0S';
        } else {
          trigger = 'TRIGGER:-P' + days + 'D';
        }
        alarms.push(
          'BEGIN:VALARM',
          trigger,
          'ACTION:DISPLAY',
          'DESCRIPTION:' + icsEscape(title),
          'END:VALARM'
        );
      });
      return alarms;
    }

    function buildIcs(title, dateParts, description, reminderDays) {
      var start = toCompact(dateParts);
      var end = toCompact(nextDay(dateParts));
      var uid =
        'keller-scholarship-' +
        start +
        '-' +
        String(title || '').toLowerCase().replace(/[^a-z0-9]+/g, '-') +
        '@keller4salon.com';
      return [
        'BEGIN:VCALENDAR',
        'VERSION:2.0',
        'PRODID:-//Keller International//Scholarship//EN',
        'CALSCALE:GREGORIAN',
        'METHOD:PUBLISH',
        'BEGIN:VEVENT',
        'UID:' + uid,
        'DTSTAMP:' + stampUtc(),
        'DTSTART;VALUE=DATE:' + start,
        'DTEND;VALUE=DATE:' + end,
        'SUMMARY:' + icsEscape(title),
        'DESCRIPTION:' + icsEscape(description)
      ]
        .concat(alarmBlocks(title, reminderDays || [], dateParts))
        .concat(['END:VEVENT', 'END:VCALENDAR'])
        .join('\r\n');
    }

    function openCalendarFile(title, dateParts, description, reminderDays) {
      var content = buildIcs(title, dateParts, description, reminderDays);
      var blob = new Blob([content], { type: 'text/calendar;charset=utf-8' });
      var url = URL.createObjectURL(blob);
      var link = document.createElement('a');
      var filename =
        'keller-scholarship-' +
        String(title || 'event').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') +
        '.ics';
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setTimeout(function () {
        URL.revokeObjectURL(url);
      }, 1000);
    }

    function getModal(fromEl) {
      var section = fromEl.closest('.scholarship-top');
      return section ? section.querySelector('[data-cal-modal]') : null;
    }

    function openModal(modal, eventRoot) {
      if (!modal || !eventRoot) return;
      var title = eventRoot.getAttribute('data-cal-title') || '';
      var dateParts = parseYmd(eventRoot.getAttribute('data-cal-date'));
      var description = eventRoot.getAttribute('data-cal-description') || '';
      var reminders = eventRoot.getAttribute('data-cal-reminders') || '1';
      if (!dateParts) return;

      var copy = modal.querySelector('[data-cal-modal-copy]');
      var google = modal.querySelector('[data-cal-provider="google"]');
      var outlook = modal.querySelector('[data-cal-provider="outlook"]');
      var apple = modal.querySelector('[data-cal-provider="apple"]');

      if (copy) {
        copy.textContent = 'Choose a calendar for "' + title + '".';
      }
      if (google) {
        google.href = googleCalendarUrl(title, dateParts, description);
      }
      [outlook, apple].forEach(function (btn) {
        if (!btn) return;
        btn.setAttribute('data-cal-title', title);
        btn.setAttribute('data-cal-date', dateParts.raw);
        btn.setAttribute('data-cal-description', description);
        btn.setAttribute('data-cal-reminders', reminders);
      });

      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
    }

    function closeModal(modal) {
      if (!modal) return;
      modal.hidden = true;
      document.documentElement.style.overflow = '';
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-faq-trigger]');
      if (trigger) {
        var root = trigger.closest('[data-scholarship-faq]');
        if (!root) return;

        var panelId = trigger.getAttribute('aria-controls');
        var panel = panelId ? document.getElementById(panelId) : null;
        if (!panel) return;

        var isOpen = trigger.getAttribute('aria-expanded') === 'true';
        var allowMultiple = root.hasAttribute('data-allow-multiple');

        if (!allowMultiple) {
          root.querySelectorAll('[data-faq-trigger]').forEach(function (otherTrigger) {
            if (otherTrigger === trigger) return;
            var otherPanel = document.getElementById(otherTrigger.getAttribute('aria-controls'));
            if (otherPanel) closeItem(otherTrigger, otherPanel);
          });
        }

        if (isOpen) {
          closeItem(trigger, panel);
        } else {
          openItem(trigger, panel);
        }
        return;
      }

      var openCal = event.target.closest('[data-cal-open]');
      if (openCal) {
        event.preventDefault();
        var eventRoot = openCal.closest('[data-cal-event]');
        var modal = getModal(openCal);
        openModal(modal, eventRoot);
        return;
      }

      var fileCalBtn = event.target.closest('[data-cal-provider="apple"], [data-cal-provider="outlook"]');
      if (fileCalBtn) {
        event.preventDefault();
        var fileDate = parseYmd(fileCalBtn.getAttribute('data-cal-date'));
        if (fileDate) {
          openCalendarFile(
            fileCalBtn.getAttribute('data-cal-title') || '',
            fileDate,
            fileCalBtn.getAttribute('data-cal-description') || '',
            parseReminders(fileCalBtn.getAttribute('data-cal-reminders'))
          );
        }
        closeModal(fileCalBtn.closest('[data-cal-modal]'));
        return;
      }

      var closeCal = event.target.closest('[data-cal-close]');
      if (closeCal) {
        event.preventDefault();
        closeModal(getModal(closeCal) || closeCal.closest('[data-cal-modal]'));
        return;
      }

      var providerLink = event.target.closest('[data-cal-provider="google"]');
      if (providerLink) {
        closeModal(providerLink.closest('[data-cal-modal]'));
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('[data-cal-modal]:not([hidden])').forEach(function (modal) {
        closeModal(modal);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
